import React from 'react'
import {
    BackButton,
    Button,
    Conditionnal,
    Header,
    ListingCreditRenego,
    ProgressBar,
} from '../ImportAll'

export default function Vue25() {
    return (
        <div>
            <Header
                title="J'estime mon prêt"
                subTitle="Montant de l'opération"
                subTitle2="Saisissez les prêts bancaires à renégocier, et l'éventuel Prêt a Taux Zéro (PTZ) dont vous bénéficiez"
            />
            <div className="Container">
                <div className="BackNavigationContainerLeft">
                    <BackButton />
                </div>
            </div>
            <div className="Container">
                <ProgressBar size={100} time={1} />
            </div>
            <div className="Container">
                <ListingCreditRenego />
            </div>

            <Conditionnal linked_data_id="credit_renego_list" isNotEmpty>
                <div className="SubmitButtonContainer">
                    {' '}
                    <Button text="Suivant" targetView={6} />
                </div>
            </Conditionnal>
        </div>
    )
}
